import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import {RiCloseLine} from "react-icons/ri";
import {Overlay, CloseBtn, Img} from "./styles";

/**
 * Lightbox de imagem (estilo WhatsApp): overlay escuro com a imagem centralizada.
 * Fecha ao clicar fora, no X ou com Esc. Renderiza via portal no body.
 */
const ImageLightbox = ({src, open, onClose}) => {
    React.useEffect(() => {
        if (!open) return undefined;
        const onKey = (e) => { if (e.key === "Escape") onClose(); };
        document.addEventListener("keydown", onKey);
        return () => document.removeEventListener("keydown", onKey);
    }, [open, onClose]);

    if (!open || !src) return null;

    return ReactDOM.createPortal(
        <Overlay onClick={onClose} data-testid="image-lightbox">
            <CloseBtn type="button" onClick={onClose} aria-label="close"><RiCloseLine/></CloseBtn>
            <Img src={src} alt="" onClick={(e) => e.stopPropagation()}/>
        </Overlay>,
        document.body,
    );
};

ImageLightbox.propTypes = {
    src: PropTypes.string,
    open: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
};

export default ImageLightbox;
